module.exports = __webpack_public_path__ + "img/warn.9ad27631.png";